import React from 'react';
import { getYouTubeEmbedUrl, normalizeLinkPreview } from '../../utils/linkPreview';
import '../../stylesheets/SocialComposerOverrides.css';

const LinkPreviewCard = ({ preview, className = '', onRemove }) => {
  const link = normalizeLinkPreview(preview);

  if (!link) {
    return null;
  }

  const youtubeEmbedUrl = getYouTubeEmbedUrl(link.url);
  const content = (
    <div className={`social-link-preview-card ${className}`.trim()}>
      {onRemove && (
        <button
          type="button"
          className="social-link-preview-remove"
          aria-label="Remove link preview"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onRemove();
          }}
        >
          &times;
        </button>
      )}
      {youtubeEmbedUrl ? (
        <div className="social-link-preview-video-frame">
          <iframe
            src={youtubeEmbedUrl}
            title={link.title || 'YouTube video preview'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      ) : link.image ? (
        <img src={link.image} alt={link.title || 'Link preview'} className="social-link-preview-image" />
      ) : null}
      <div className="social-link-preview-content">
        <h6 className="social-link-preview-title">{link.title}</h6>
        {link.description ? <p className="social-link-preview-description">{link.description}</p> : null}
        <p className="social-link-preview-url">{link.siteName || link.url}</p>
      </div>
    </div>
  );

  if (onRemove || youtubeEmbedUrl) {
    return content;
  }

  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className="social-link-preview-link"
      onClick={(event) => event.stopPropagation()}
    >
      {content}
    </a>
  );
};

export default LinkPreviewCard;
